// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { Observable, BehaviorSubject } from 'rxjs';

// --- HS Code
import { EmailAddressValidationModel, RegistrationModel, RegistrationResult, ResolvedTokenModel } from '../../../models';

// #endregion

@Injectable()
export abstract class RegistrationBaseService {

  protected _isRegistering$: BehaviorSubject<boolean>;
  get isRegistering$(): Observable<boolean> {
    return this._isRegistering$;
  }

  protected _isRegistered$: BehaviorSubject<boolean>;
  get isRegistered$(): Observable<boolean> {
    return this._isRegistered$;
  }

  protected _registrationResult$: BehaviorSubject<RegistrationResult>;
  get registrationResult$(): Observable<RegistrationResult> {
    return this._registrationResult$;
  }

  protected _isEmailAddressInUse$: BehaviorSubject<EmailAddressValidationModel>;
  get isEmailAddressInUse$(): Observable<EmailAddressValidationModel> {
    return this._isEmailAddressInUse$;
  }

  protected _registrationResolutionResult$: BehaviorSubject<ResolvedTokenModel>;
  get registrationResolutionResult$(): Observable<ResolvedTokenModel> {
    return this._registrationResolutionResult$;
  }

  protected _emailAddress$: BehaviorSubject<string>;
  get emailAddress$(): Observable<string> {
    return this._emailAddress$;
  }

  protected _isValidatingEmailAddress$: BehaviorSubject<boolean>;
  get isValidatingEmailAddress$(): Observable<boolean> {
    return this._isValidatingEmailAddress$;
  }

  protected _registrationError$: BehaviorSubject<string>;
  get registrationError$(): Observable<string> {
    return this._registrationError$;
  }

  constructor() {
    this._isEmailAddressInUse$ = new BehaviorSubject<
    EmailAddressValidationModel
    >({
      isValidEmailAddress: false,
      isEmailAddressValidated: false,
      emailAddressExists: false
    } as EmailAddressValidationModel);
    this._isRegistering$ = new BehaviorSubject<boolean>(false);
    this._isRegistered$ = new BehaviorSubject<boolean>(false);
    this._registrationResult$ = new BehaviorSubject<RegistrationResult>(null);
    this._registrationResolutionResult$ = new BehaviorSubject<ResolvedTokenModel>(null);
    this._emailAddress$ = new BehaviorSubject<string>(null);
    this._isEmailAddressInUse$ = new BehaviorSubject<EmailAddressValidationModel>(null);
    this._isValidatingEmailAddress$ = new BehaviorSubject<boolean>(false);
    this._registrationError$ = new BehaviorSubject<string>(null);
  }

  abstract clearState(): void;
  abstract registerNewUser(registration: RegistrationModel): void;
  abstract checkIfEmailAddressInUse(emailAddress: string): void;
  abstract resendRegistrationEmail(emailAddress: string): void;
}
